import React, { useContext } from 'react';
import styled from 'styled-components';

import { rem } from '@vimeo/bokeh';
import { translate } from '@vimeo/i18n-runtime';
import { slate } from '@vimeo/iris/color';
import { Paragraph } from '@vimeo/iris/typography';
import { ViewerContext } from '@vimeo/viewer';

import ExpandableList from '../../ExpandableList';
import { Copyright } from '../Copyright';
import DoNotSellLink from '../DoNotSellLink';
import * as Links from '../Links';
import { ModalCTAs } from '../MinimalFooter';

const Footer = styled.footer`
  display: flex;
  flex-direction: column;
  @media (min-width: ${rem(768)}) {
    display: none;
  }
`;

const Section = styled.div`
  margin: 0 ${rem(24)};
  padding: ${rem(12)} 0;
`;

const BorderedSection = styled.div`
  margin: 0 ${rem(20)};
  border-bottom: solid 1px ${slate(50)};
`;

const Text = styled(Paragraph).attrs({ size: '1' })`
  color: ${slate(800)};
  margin: 0;
  &:hover {
    color: ${slate(200)};
  }
`;

interface Props {
  impressumQualifies?: boolean;
  modalCtas: ModalCTAs;
  isDoNotSellReady?: boolean;
}

function MobileMinimalFooter({ impressumQualifies, modalCtas, isDoNotSellReady }: Props) {
  const viewer = useContext(ViewerContext);
  const isSimplifiedSite = viewer?.isSimplifiedSite;

  return (
    <Footer>
      <BorderedSection>
        <Text>
          <Links.Upgrade />
        </Text>
      </BorderedSection>
      <ExpandableList
        location="minimalFooter"
        title={translate('Legal')}
        items={[
          Links.getLegalLinks()
            .filter(
              (link) =>
                (impressumQualifies ? true : link.title !== 'Impressum') &&
                (!isSimplifiedSite || link.forSimplifiedSite === isSimplifiedSite),
            )
            .map((link, index) => (
              <Links.Link key={`link-${index}`} href={link.href} title={link.title}>
                {link.title}
              </Links.Link>
            )),
          <DoNotSellLink
            key="link-do-not-sell"
            footerType="minimalMobile"
            isDoNotSellReady={isDoNotSellReady}
          />,
        ]}
      />
      <ExpandableList
        location="minimalFooter"
        title={translate('More')}
        items={[
          <Links.Link key="language-link" onClick={modalCtas.language.open}>
            {modalCtas.language.text}
          </Links.Link>,
          <Links.Help key="help-link" />,
          <Links.Link key="preferences-link" onClick={modalCtas.contentPrefs.open}>
            {modalCtas.contentPrefs.text}
          </Links.Link>,
        ]}
      />
      <Section>
        <Copyright />
      </Section>
    </Footer>
  );
}

export default MobileMinimalFooter;
